module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.6.1
 ** module id = 118
 ** module chunks = 0
 **/